var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"datamatrix-container"},[_c('canvas',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],ref:"datamatrixCanvas",style:({
      width: _vm.width,
      height: _vm.height,
      backgroundColor: 'white',
      border: '5px solid #fff',
    }),attrs:{"alt":"Datamatrix code","title":_vm.noTooltip ? undefined : _vm.encodeString},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.emulateKeyboardScan.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }